import React from 'react';
import Reflux from 'reflux';
import Modal from 'react-modal';
import Field from '../../common/Field';
import Validator from '../../common/Validator';
import i18 from '../../../i18';
import {customerRuleApi} from '../../../api';

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
    },
};

class RuleUpdateModal extends Reflux.Component {
    constructor(props) {
        super(props);

        this.state = {
            fields: this.createInitialFields(props.rule),
            saving: false,
        };
    }

    createInitialFields = (rule) => {
        return {
            item_name: this.createField(rule.item_name, false),
            invoice_number: this.createField(rule.invoice_number, false),
            order_number_stat: this.createField(rule.order_number_stat, false),
            main_bookkeeping_number: this.createField(rule.main_bookkeeping_number, true),
            vat: this.createField(rule.vat, true),
            vat_degree: this.createField(rule.vat_degree, false),
            collector_code_fk_id: this.createField(rule.collector_code_fk_id, true),
            company_type: this.createField(rule.company_type, true),
            type: this.createField(rule.type, true),
            position_number: this.createField(rule.position_number, false),
            position_number_country: this.createField(rule.position_number_country, false),
            position: this.createField(rule.position, true),
        };
    };

    createField = (value, required) => {
        return {
            value: value === null || typeof value === 'undefined' ? '' : value,
            error: '',
            role: {required: required},
        };
    };

    getCompanyId = () => {
        return this.props.config.company_id;
    };

    hasRuleFilter = () => {
        const fields = this.state.fields;

        return (
            String(fields.item_name.value).trim() !== ''
            || String(fields.invoice_number.value).trim() !== ''
            || String(fields.order_number_stat.value).trim() !== ''
            || String(fields.position_number.value).trim() !== ''
            || String(fields.position_number_country.value,).trim() !== ''
        );
    };

    isVatDegreeDisabled = () => {
        return String(this.state.fields.collector_code_fk_id.value) === '3';
    };

    validateRule = () => {
        if (!this.hasRuleFilter()) {
            this.props.notifyError(
                'A szabály létrehozásához ki kell választani, '
                + 'hogy mely adatokra legyen érvényes!',
            );

            return false;
        }

        const fields = this.prepareFieldsForValidation();
        const validator = Validator.validate(fields);

        if (validator.error) {
            this.setState({
                fields: validator.fields,
            });

            return false;
        }

        return true;
    };

    prepareFieldsForValidation = () => {
        const fields = Object.assign(
            {},
            this.state.fields,
        );

        fields.vat_degree = Object.assign(
            {},
            fields.vat_degree,
            {
                role: Object.assign(
                    {},
                    fields.vat_degree.role,
                    {
                        required:
                            !this.isVatDegreeDisabled(),
                    },
                ),
            },
        );

        return fields;
    };

    buildPayload = () => {
        const fields = this.state.fields;

        return {
            company_type: fields.company_type.value,
            position: fields.position.value,
            item_name: this.getNullableStringValue(fields.item_name),
            invoice_number: this.getNullableStringValue(fields.invoice_number),
            order_number_stat: this.getNullableStringValue(fields.order_number_stat),
            type: fields.type.value,
            position_number: this.getNullableStringValue(fields.position_number),
            position_number_country: this.getNullableStringValue(fields.position_number_country),
            main_bookkeeping_number: this.getNullableStringValue(fields.main_bookkeeping_number),
            vat: fields.vat.value,
            vat_degree: this.isVatDegreeDisabled() ? null : this.getNullableStringValue(fields.vat_degree),
            collector_code_fk_id: fields.collector_code_fk_id.value,
        };
    };

    updateRule = async () => {
        if (this.state.saving) {
            return;
        }

        if (!this.validateRule()) {
            return;
        }

        this.setState({
            saving: true,
        });

        try {
            const data = await customerRuleApi.update(
                this.getCompanyId(),
                this.props.rule.id,
                this.buildPayload(),
            );

            this.props.updateRules(
                data.customerRules,
            );

            this.props.notifySuccess(
                'A szabály szerkesztése sikeres.',
            );

            this.props.editRule(null);

        } catch (error) {
            console.error('Rule update error:', error);

            this.setState({
                saving: false,
            });

            if (
                error
                && error.response
                && error.response.status === 422
            ) {
                const responseData =
                    error.response.data;

                this.props.notifyError(
                    responseData
                    && responseData.message
                        ? responseData.message
                        : 'A megadott adatok hibásak.',
                );

                return;
            }

            this.props.notifyError(
                'A szabály mentése sikertelen.',
            );
        }
    };

    setValue = (name, value, error) => {
        const fields = Object.assign(
            {},
            this.state.fields,
        );

        fields[name] = Object.assign(
            {},
            fields[name],
            {
                value: value,
                error: error,
            },
        );

        this.setState({
            fields: fields,
        });
    };

    onElementChange = (event) => {
        this.setValue(
            event.target.name,
            event.target.value,
            '',
        );
    };

    closeModal = () => {
        if (this.state.saving) {
            return;
        }

        this.props.editRule(null);
    };

    renderTextField = (
        name,
        label,
        extraProps,
    ) => {
        const props = extraProps || {};

        return (
            <Field
                {...props}
                type="text"
                id={name}
                name={name}
                label={label}
                classLabel={
                    'control-label '
                    + 'margin-bottom-2 '
                    + 'margin-top-10'
                }
                classInput="form-control"
                setValue={this.setValue}
                state={this.state}
                style={{
                    width: '100%',
                    minWidth: '350px',
                }}
            />
        );
    };

    getNullableStringValue = (field) => {
        const value = String(field.value).trim();

        return value === '' ? null : value;
    };

    render() {
        const {
            rule,
            vatCollectorCodes,
        } = this.props;

        if (!rule) {
            return null;
        }

        const vatDegreeDisabled =
            this.isVatDegreeDisabled();

        return (
            <div>
                <Modal
                    isOpen={true}
                    onRequestClose={this.closeModal}
                    shouldCloseOnOverlayClick={
                        !this.state.saving
                    }
                    shouldCloseOnEsc={
                        !this.state.saving
                    }
                    style={customStyles}
                >
                    <h4>
                        #{rule.id}{' '}
                        {i18.COMMON._editRuleText}
                    </h4>

                    <div className="modal-body">
                        {this.renderTextField(
                            'item_name',
                            i18.CUSTOMER._typeOfTraffic,
                        )}

                        {this.renderTextField(
                            'invoice_number',
                            i18.CUSTOMER._invoiceNumber,
                        )}

                        {this.renderTextField(
                            'order_number_stat',
                            i18.CUSTOMER._orderNumberStat,
                        )}

                        {this.renderTextField(
                            'vat',
                            i18.CUSTOMER._VAT,
                        )}

                        <label
                            htmlFor="company_type"
                            className={
                                'margin-top-10 '
                                + 'margin-bottom-2 '
                                + 'control-label'
                            }
                        >
                            {i18.CUSTOMER._taxNumber}
                        </label>

                        <select
                            value={
                                this.state.fields
                                    .company_type.value
                            }
                            name="company_type"
                            id="company_type"
                            onChange={
                                this.onElementChange
                            }
                            className="minimal-100 form-control"
                            disabled={this.state.saving}
                        >
                            <option value="EU">
                                {i18.COMMON._eu}
                            </option>

                            <option value="HU">
                                {i18.COMMON._hu}
                            </option>

                            <option value="NON_EU">
                                {i18.COMMON._non_eu}
                            </option>
                        </select>

                        {this.renderTextField(
                            'position',
                            i18.CUSTOMER._POSITION,
                        )}

                        {this.renderTextField(
                            'main_bookkeeping_number',
                            i18.CUSTOMER._mainBookNumber,
                        )}

                        <label
                            htmlFor="collector_code_fk_id"
                            className={
                                'margin-top-10 '
                                + 'margin-bottom-2 '
                                + 'control-label'
                            }
                        >
                            {i18.CUSTOMER._collectorCode}
                        </label>

                        <select
                            value={
                                this.state.fields
                                    .collector_code_fk_id
                                    .value
                            }
                            name="collector_code_fk_id"
                            id="collector_code_fk_id"
                            onChange={
                                this.onElementChange
                            }
                            className="minimal-100 form-control"
                            disabled={this.state.saving}
                        >
                            <option value="">
                                Kérjük, válasszon
                            </option>

                            {vatCollectorCodes.map(
                                (collectorCode) => (
                                    <option
                                        value={
                                            collectorCode.id
                                        }
                                        key={
                                            collectorCode.id
                                        }
                                    >
                                        {collectorCode.code}
                                        &nbsp;
                                        ({collectorCode.title})
                                    </option>
                                ),
                            )}
                        </select>

                        {this.renderTextField(
                            'vat_degree',
                            i18.CUSTOMER
                                ._vatDegreeNumber,
                            {
                                disabled:
                                    vatDegreeDisabled
                                    || this.state.saving,
                            },
                        )}

                        <label
                            htmlFor="type"
                            className={
                                'margin-top-10 '
                                + 'margin-bottom-2 '
                                + 'control-label'
                            }
                        >
                            {i18.COMMON._typeOfRule}
                        </label>

                        <select
                            value={
                                this.state.fields.type.value
                            }
                            name="type"
                            id="type"
                            onChange={
                                this.onElementChange
                            }
                            className="minimal-100 form-control"
                            disabled={this.state.saving}
                        >
                            <option value="temporarily">
                                {
                                    i18.COMMON
                                        ._temporarirlyRule
                                }
                            </option>

                            <option value="final">
                                {i18.COMMON._finalRule}
                            </option>
                        </select>
                        {this.renderTextField(
                            'position_number',
                            i18.CUSTOMER
                                ._positionNumber,
                        )}
                        {this.renderTextField(
                            'position_number_country',
                            i18.CUSTOMER
                                ._positionNumberCountry,
                        )}
                    </div>

                    <div className="modal-footer text-center">
                        <button
                            type="button"
                            onClick={this.updateRule}
                            className="btn btn-success btn-sm mr-2"
                            disabled={this.state.saving}
                        >
                            {this.state.saving
                                ? 'Mentés...'
                                : i18.COMMON._save}
                        </button>

                        <button
                            type="button"
                            onClick={this.closeModal}
                            className="btn btn-danger btn-sm"
                            disabled={this.state.saving}
                        >
                            {i18.COMMON._close}
                        </button>
                    </div>
                </Modal>
            </div>
        );
    }
}

export default RuleUpdateModal;


// WEBPACK FOOTER //
// ./src/components/customer/rules/RuleUpdateModal.js